import { configureStore } from '@reduxjs/toolkit';
import popupState from './popupState';
import createProjectState from './createProjectState';

const store = configureStore({
  reducer: {
    popupState,
    createProjectState
  }
});

export default store;
